<template>
  <div class="fixed z-10 inset-0 overflow-y-auto" style="min-height: 500px;">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6"
          role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" @click="closeModal"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
            <span class="sr-only">Close</span>
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
            <div class="mt-3 text-center sm:mt-0 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                {{transEdit('therapist-add-schedule')}} {{date}}
              </h3>
            </div>
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <label for="schedule_start" class="block text-sm font-medium text-gray-700">
                  {{transEdit('start')}}
                </label>
                <div class="mt-1">
                  <input v-model="schedule_start" type="time"
                            class="max-w-lg w-full shadow-sm focus:ring-tlmblue2 focus:border-tlmblue2 sm:text-sm border-gray-300 rounded-md">
                </div>
              </div>
            </div>
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <label for="schedule_end" class="block text-sm font-medium text-gray-700">
                  {{transEdit('end')}}
                </label>
                <div class="mt-1">
                  <input v-model="schedule_end" type="time"
                            class="max-w-lg w-full shadow-sm focus:ring-tlmblue2 focus:border-tlmblue2 sm:text-sm border-gray-300 rounded-md">
                </div>
              </div>
            </div>
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <label for="schedule_end" class="block text-sm font-medium text-gray-700">
                  {{transEdit('company')}}
                </label>
                <div class="mt-1">
                  <vue-multiselect v-model="selectedCompany" :options="companies" label="name" :max-height="130" placeholder="Välj företag" @select="updateLists"></vue-multiselect>
                </div>
              </div>
            </div>
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <label for="schedule_end" class="block text-sm font-medium text-gray-700">
                  {{transEdit('location')}}
                </label>
                <div class="mt-1">
                  <vue-multiselect v-model="selectedLocation" :options="filterLocations" :max-height="130" label="address" placeholder="Välj lokal" open-direction="below"></vue-multiselect>
                </div>
              </div>
            </div>
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <label for="schedule_end" class="block text-sm font-medium text-gray-700">
                  {{transEdit('treatments')}}
                </label>
                <div class="mt-1">
                  <vue-multiselect v-model="selectedTreatment" :options="treatments" :max-height="130" label="name" placeholder="Välj behandlingar" open-direction="above"  @select="getLocations" :multiple="true"></vue-multiselect>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div>
                <span v-if="loading"><i class="fa fa-spin fa-fw fa-refresh"></i> {{transEdit('loading')}}...</span>
              </div>
              <div class="text-danger">
                <span v-if="error">{{transEdit('admin.schedules.create.conflicts-exist')}}</span>
              </div>

            </div>
          </div>
          <div class="pt-5">
            <div class="flex justify-end">
              <button type="button" @click="closeModal"
                      class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
                {{ transEdit('cancel') }}
              </button>
              <button type="submit" @click="addSchedule"
                      class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-tlmblue2 hover:bg-tlmblue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
                {{ transEdit('therapist-add-schedule') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import VueMultiselect from "vue-multiselect/src/Multiselect";
    export default {
        name: "therapist-dash-modal-add-schedule",
        components: {VueMultiselect},
        props: ['route_delete_day', 'therapist_self_admin', 'date', 'schedule'],
        data() {
            return {
                schedule_start: '12:00',
                schedule_end: '12:30',
                companies: [],
                selectedCompany: null,
                locations: [],
                selectedLocation: null,
                treatments: [],
                selectedTreatment: null,
                loading: false,
                error: false,
            }
        },
        computed: {
            filterLocations() {
                let simplifiedLocations = [];
                if(this.locations){
                    this.locations.forEach((location) => {
                        let tempAddressString = location.city.name + ' ' + location.address;
                        simplifiedLocations.push({
                            id: location.id,
                            address: tempAddressString,
                        });
                    });
                }

                return simplifiedLocations;
            },
        },
      created() {
        if(this.schedule && this.schedule.location) {
          this.selectedLocation = {address: this.schedule.location.address, id: this.schedule.location.id};
          if(this.schedule.treatments.length) {
            this.selectedTreatment = [this.schedule.treatments[0]];
          }
          if(this.schedule.location.primary_company) {
            this.selectedCompany = this.schedule.location.primary_company
          }
        }
      },
        methods: {
            getCompanies() {
              this.loading = true;
              axios.get('therapists-pages/schedule/companies').then((res) => {
                  this.companies = res.data;
                  this.loading = false;
              });
            },
            getLocations(company) {
                this.loading = true;
                axios.get('therapists-pages/schedule/locations?company_id=' + company.id).then((res) => {
                    this.locations = res.data;
                    this.loading = false;
                });
            },
            getTreatments(company){
                this.loading = true;
                axios.get('therapists-pages/schedule/treatments?company_id=' + company.id).then((res) => {
                        this.treatments = res.data;
                        this.loading = false;
                });
            },
            updateLists(company) {
                this.getLocations(company);
                this.getTreatments(company);
            },
            addSchedule: function () {
                this.error = false;
                let thisModal = $("#add-schedule-modal");
                axios.post(this.$portalUrl('therapists-pages/schedule'), {
                    company_id: this.selectedCompany ? this.selectedCompany.id : null,
                    location_id: this.selectedLocation ? this.selectedLocation.id : null,
                    treatment_ids: this.getTreatmentIds(),
                    date: this.date,
                    start: this.schedule_start,
                    end: this.schedule_end,
                }).then((res) => {
                    this.loading = false;
                    this.$emit('close');
                    thisModal.modal('toggle');
                }).catch((res) => {
                    this.error = true;
                });
            },

            getTreatmentIds() {
                if(!this.selectedTreatment || !this.selectedTreatment.length) return [];
                let ids = [];
                for(let treatment of this.selectedTreatment) {
                    ids.push(treatment.id);
                }

                return ids;
            },
          closeModal() {
            this.$emit('close');
          },
        },
        mounted() {
            this.loading = true;
            this.getCompanies();
        }
    }
</script>

<style scoped>

</style>
